module.exports = __webpack_public_path__ + "img/plan4_book03.dc4956ee.png";